exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colors[data-v-17d3d50c]{color:black}@media (max-width: 1024px){.colors[data-v-17d3d50c]{color:#2d2d2d}}.minicart-count[data-v-17d3d50c]{top:1px;left:20px;min-width:16px;min-height:16px;border-radius:10px}@media (max-width: 1024px){.microcart-btn[data-v-17d3d50c]{-ms-flex-direction:column;flex-direction:column}}.microcart-btn__text[data-v-17d3d50c]{font-size:14px;padding-left:5px}@media (max-width: 1024px){.microcart-btn__text[data-v-17d3d50c]{font-size:12px;padding:0}}\n", ""]);

// exports
